import styled from 'styled-components/macro'
import { transparentize } from 'polished'

export const WrapperEditor = styled.div`
  margin: 0 0 3.2rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`

export const Top = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: space-between;
  gap: 1.6rem;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    flex-direction: row;
    align-items: flex-end;
  `};
`

export const Label = styled.label`
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.5;
  color: ${(props) => props.theme.color.textThird};
`

export const ButtonWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.4rem;
`

export const WrapEditor = styled.div`
  padding: 0;
  display: flex;
  flex: 0 0 auto;
  width: 100%;
  height: 16.8rem;

  &.dragAndDrop {
    position: relative;
    height: 16.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: ${(props) => transparentize(0.96, props.theme.color.text)};
    border: 0.1rem solid ${(props) => props.theme.color.inputColor};
    border-radius: 0.8rem;
    box-shadow: none;
    transition: color 0.26s ease, box-shadow 0.26s ease;
    cursor: pointer;
    overflow: hidden;

    &:hover:not([disabled]) {
      box-shadow: 0 0 0 0.3rem ${(props) => transparentize(0.7, props.theme.color.inputColor)};
    }
  }
`

export const ErrorsWrap = styled.div`
  margin: 0 0 0.8rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
`
